import './App.css';
import { useEffect, useState } from 'react';

function FeatureCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const featureImages = [
    'feature1.jpg',
    'feature2.jpg',
    'feature3.jpg',
    'feature4.jpg',
    'feature5.jpg',
    'feature6.jpg'
  ];

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? featureImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === featureImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="flex items-center justify-center md:justify-end gap-4">
      <button
        onClick={handlePrevious}
        className="flex-shrink-0 w-10 h-10 rounded-full bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center justify-center shadow-lg transition-colors"
        aria-label="Previous image"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div className="relative w-full max-w-60">
        <img
          src={process.env.PUBLIC_URL + '/' + featureImages[currentIndex]}
          alt={`RouteNode feature ${currentIndex + 1}`}
          className="w-full h-auto rounded-lg shadow-lg"
        />
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {featureImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentIndex ? 'bg-green-600' : 'bg-white/60 hover:bg-white/80'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      </div>
      <button
        onClick={handleNext}
        className="flex-shrink-0 w-10 h-10 rounded-full bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center justify-center shadow-lg transition-colors"
        aria-label="Next image"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}

function WorldDotsBackground({ isVisible }) {
  const totalCells = 35 * 55;

  const northAmerica = new Set([
    19, 20, 21, 73, 74, 75, 76, 77, 123, 124, 127, 128, 129, 130, 131, 132, 177,
    178, 179, 181, 182, 183, 184, 185, 186, 187, 188, 228, 229, 230, 231, 232,
    233, 234, 237, 238, 239, 240, 241, 242, 243, 283, 284, 285, 286, 287, 288,
    289, 293, 294, 295, 296, 297, 332, 333, 334, 337, 339, 340, 341, 342, 343,
    348, 349, 350, 351, 352, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396,
    397, 398, 399, 404, 405, 406, 407, 441, 442, 443, 444, 445, 446, 447, 448,
    449, 450, 451, 452, 453, 454, 455, 459, 460, 497, 498, 499, 500, 501, 502,
    503, 504, 505, 506, 507, 509, 510, 511, 514, 552, 553, 554, 555, 556, 557,
    558, 559, 560, 561, 562, 564, 565, 566, 607, 610, 611, 612, 613, 614, 615,
    616, 619, 620, 621, 622, 666, 667, 668, 669, 670, 671, 672, 674, 675, 676,
    722, 723, 724, 725, 726, 727, 728, 729, 730, 731, 778, 779, 780, 781, 782,
    783, 784, 785, 786, 834, 835, 836, 837, 838, 839, 889, 890, 891, 892, 893,
    894, 944, 945, 946, 947, 948, 949, 1000, 1001, 1002, 1005, 1056, 1057, 1112,
    1113, 1114, 1169,
  ]);

  const southAmerica = new Set([
    1225, 1226, 1227, 1228, 1229, 1281, 1282, 1283, 1284, 1285, 1335, 1336, 1337,
    1338, 1339, 1340, 1341, 1342, 1390, 1391, 1392, 1393, 1394, 1395, 1396, 1397,
    1446, 1447, 1448, 1449, 1450, 1451, 1502, 1503, 1504, 1505, 1506, 1557, 1558,
    1559, 1560, 1612, 1613, 1614, 1666, 1667, 1668, 1721, 1722, 1776, 1777, 1831,
    1832, 1887,
  ]);

  const europe = new Set([
    361, 362, 415, 416, 417, 469, 470, 471, 472, 523, 524, 525, 527, 582, 580,
    579, 578, 632, 634, 636, 631, 311, 312, 251, 519, 520, 686, 687, 689, 688,
    690, 691, 692, 637, 638, 583, 528, 473, 418, 474, 475, 365, 421, 476, 477,
    531, 530, 529, 584, 585, 586, 639, 640, 641, 693, 694, 695, 696, 795, 796,
    850, 851, 797, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 805, 804,
    803, 802, 801, 799, 798, 800, 854, 856, 857, 911,
  ]);

  const africa = new Set([
    961, 962, 963, 965, 1020, 1021, 1019, 1018, 1017, 1016, 1015, 1069, 1070,
    1071, 1072, 1073, 1074, 1075, 1076, 1077, 1124, 1125, 1126, 1127, 1128, 1129,
    1130, 1131, 1132, 1133, 1179, 1180, 1181, 1182, 1183, 1184, 1185, 1186, 1187,
    1188, 1189, 1235, 1236, 1237, 1238, 1239, 1240, 1241, 1242, 1243, 1244, 1293,
    1294, 1295, 1296, 1297, 1298, 1348, 1349, 1350, 1351, 1352, 1404, 1405, 1406,
    1407, 1459, 1460, 1461, 1462, 1514, 1515, 1516, 1518, 1573, 1569, 1570, 1571,
    1624, 1625,
  ]);

  const asia = new Set([
    154, 208, 209, 210, 262, 263, 264, 265, 314, 315, 316, 317, 318, 319, 320,
    321, 322, 323, 325, 326, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378,
    379, 380, 381, 382, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433,
    434, 435, 436, 437, 438, 439, 440, 478, 479, 480, 481, 482, 483, 484, 485,
    486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 532, 533, 534, 535, 536,
    537, 538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, 587,
    588, 589, 590, 591, 592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 603,
    642, 643, 644, 645, 646, 647, 648, 649, 650, 651, 652, 653, 654, 657, 658,
    697, 698, 699, 700, 701, 702, 703, 704, 705, 706, 707, 708, 709, 712, 752,
    753, 754, 755, 756, 757, 758, 759, 760, 761, 762, 763, 764, 807, 808, 809,
    810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 821, 859, 860, 861, 862,
    863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 876, 913, 914, 916,
    917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 928, 930, 967, 968, 969,
    970, 972, 973, 974, 975, 976, 977, 978, 979, 980, 981, 982, 1022, 1023, 1024,
    1025, 1026, 1027, 1029, 1030, 1031, 1034, 1035, 1036, 1037, 1079, 1080, 1081,
    1085, 1089, 1090, 1135, 1144, 1145, 1200, 1202, 1203, 1255, 1256, 1257, 1311,
  ]);

  const australia = new Set([
    1206, 1262, 1263, 1317, 1369, 1370, 1372, 1422, 1423, 1424, 1425, 1426, 1427,
    1428, 1476, 1477, 1478, 1479, 1480, 1481, 1482, 1483, 1531, 1532, 1533, 1534,
    1535, 1536, 1537, 1538, 1586, 1587, 1590, 1591, 1592, 1645, 1646, 1650, 1705,
  ]);

  const getContinentClass = (index) => {
    if (northAmerica.has(index)) return 'world-dot-north-america';
    if (southAmerica.has(index)) return 'world-dot-south-america';
    if (europe.has(index)) return 'world-dot-europe';
    if (africa.has(index)) return 'world-dot-africa';
    if (asia.has(index)) return 'world-dot-asia';
    if (australia.has(index)) return 'world-dot-australia';
    return '';
  };

  const cells = [];
  for (let i = 1; i <= totalCells; i += 1) {
    const continentClass = getContinentClass(i);
    const hasAnimation = continentClass !== '';
    const delaySeconds = hasAnimation ? -Math.random() * 5 : 0;

    cells.push(
      <div
        key={i}
        className={`world-dot ${continentClass}`}
        style={hasAnimation ? { animationDelay: `${delaySeconds}s` } : undefined}
      />,
    );
  }

  return (
    <div className={`world-dots-wrapper ${isVisible ? 'world-dots-visible' : ''}`}>
      <div className="world-dots-container">{cells}</div>
    </div>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dotsVisible, setDotsVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDotsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <header className="fixed top-0 left-0 right-0 z-50 bg-emerald-900/95 backdrop-blur border-b border-emerald-950">
        <div className="mx-auto max-w-6xl h-16 px-4 flex items-center justify-between">
          <div className="text-lg font-semibold tracking-tight text-white">RouteNode</div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-white/90">
            <a href="#home" className="hover:text-white">Home</a>
            <a href="#features" className="hover:text-white">Features</a>
            <a href="#diagrams" className="hover:text-white">Diagrams</a>
            <a href="#videos" className="hover:text-white">Videos</a>
            <a href="#collaborators" className="hover:text-white">Collaborators</a>
            <a href="#faq" className="hover:text-white">FAQ</a>
          </nav>
          <button
            type="button"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-emerald-800 focus:outline-none focus:ring-2 focus:ring-emerald-400"
          >
            <svg
              className={`h-6 w-6 ${menuOpen ? 'hidden' : 'block'}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg
              className={`h-6 w-6 ${menuOpen ? 'block' : 'hidden'}`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </header>

      {menuOpen && (
        <div className="fixed top-16 left-0 right-0 z-40 bg-emerald-900 border-b border-emerald-950 md:hidden">
          <nav className="mx-auto max-w-6xl px-4 py-3 flex flex-col gap-3 text-sm font-medium text-white/90">
            <a href="#home" className="hover:text-white" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="#features" className="hover:text-white" onClick={() => setMenuOpen(false)}>Features</a>
            <a href="#diagrams" className="hover:text-white" onClick={() => setMenuOpen(false)}>Diagrams</a>
            <a href="#videos" className="hover:text-white" onClick={() => setMenuOpen(false)}>Videos</a>
            <a href="#collaborators" className="hover:text-white" onClick={() => setMenuOpen(false)}>Collaborators</a>
            <a href="#faq" className="hover:text-white" onClick={() => setMenuOpen(false)}>FAQ</a>
          </nav>
        </div>
      )}

      <main className="pt-16">
        <section
          id="home"
          className="relative min-h-screen scroll-mt-20 flex items-center justify-center bg-emerald-950 overflow-hidden"
        >
          <div className="relative z-10 mx-auto w-full max-w-6xl px-4 py-12 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="text-left -mt-6 md:-mt-12">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">RouteNode</h1>
              <p className="text-xl md:text-2xl text-white/80">Plan your personalized route and get smart place recommendations</p>
              <div className="mt-6 flex items-center gap-4">
                <a
                  href={process.env.PUBLIC_URL + '/RouteNode.apk'}
                  download="RouteNode.apk"
                  className="inline-flex items-center rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                  Download APK
                </a>
                <a
                  href="https://github.com/mark2515/RouteNode"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-md bg-gray-200 px-4 py-2 text-sm font-medium text-gray-800 shadow hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
                >
                  View GitHub
                </a>
              </div>
            </div>
          </div>
          <WorldDotsBackground isVisible={dotsVisible} />
        </section>

        <section id="features" className="min-h-screen scroll-mt-20 flex flex-col items-center justify-center bg-emerald-50">
          <div className="mx-auto w-full max-w-6xl px-4 py-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-2xl font-semibold mb-6 text-center md:text-left">Features</h2>
              <ul className="list-disc list-inside space-y-3 text-gray-800">
                <li>Help users create multiple stops to build their own customized route</li>
                <li>Use AI to provide more detailed place recommendations</li>
                <li>Let users update their route plan at any time</li>
                <li>Integrate Google Maps for quick and smooth route navigation</li>
              </ul>
            </div>
            <FeatureCarousel />
          </div>
        </section>

        <section id="diagrams" className="min-h-screen scroll-mt-20 flex flex-col items-center justify-center bg-emerald-50">
          <div className="mx-auto w-full max-w-4xl px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Diagrams</h2>
            <div className="w-full">
              <h3 className="text-lg font-medium mb-3">MVVM Diagram</h3>
              <div className="w-full rounded-lg shadow overflow-hidden">
                <img src="/MVVM.png" alt="MVVM Diagram" className="w-full h-auto" />
              </div>
            </div>
          </div>

          <div className="mx-auto w-full max-w-4xl px-4 py-8">
            <div className="w-full">
              <h3 className="text-lg font-medium mb-3">The threaded design diagram</h3>
              <div className="w-full rounded-lg shadow overflow-hidden">
                <img src="/threaded_design_diagram.png" alt="threaded design diagram" className="w-full h-auto" />
              </div>
            </div>
          </div>
        </section>

        <section id="videos" className="min-h-screen scroll-mt-20 flex flex-col items-center justify-center bg-emerald-50">
          <div className="mx-auto w-full max-w-4xl px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Video</h2>

            <div className="space-y-10">
              <div>
                <div className="relative w-full pt-[56.25%] rounded-lg shadow overflow-hidden bg-black">
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src="https://www.youtube.com/embed/mIWifMZ4x0k"
                    title="Final Presentation"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="collaborators" className="min-h-screen scroll-mt-20 flex flex-col items-center justify-center bg-emerald-50">
          <div className="mx-auto w-full max-w-4xl px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">Collaborators</h2>
            <div className="space-y-6">
              <div className="rounded-lg border bg-white p-4 shadow">
                <div className="text-base font-semibold">Kunlong He</div>
                <div className="text-sm text-gray-600">
                  <a href="mailto:member1@example.com" className="text-blue-600 hover:underline">kha112@sfu.ca</a>
                </div>
                <div className="text-sm mt-1">
                  Show & Tell 1: <br />
                  • Use Figma to design project prototypes and help the team quickly understand the UI layout and functional structure <br />
                  • Created an MVVM diagram that clearly shows the relationships between the Model, the View, and the ViewModel in our app <br />
                  • Built the UI for the Search fragment <br />
                  • Made the whole Show & Tell 1 video <br />
                  <br /> Show & Tell 2: <br />
                  • Integrated the OpenAI API into the project by loading keys with BuildConfig, building a simple OkHttp-based OpenAiService, creating clear route-planning prompts, and wiring everything into the ViewModel and Markdown preview so users get easy-to-read AI suggestions <br />
                  • Implemented features to copy, retry, and favorite AI responses <br />
                  • Created the threaded design diagram, and made clear how UI updates happen on the Main thread <br />
                  • Took part in the Show & Tell 2 video <br />
                  <br /> Final: <br />
                  • Configured AI model settings, including GPT model selection, temperature and token limits <br />
                  • Added dynamic distance units and response language parameters to AI prompts, ensuring model instructions correctly reflect user selections <br />
                  • Ran a lot of testing on the project and found several threading and integration problems, and fixed 10+ of them <br />
                  • Designed and built the webpage <br />
                  • Prepared the PPT and recorded the half of the presentation <br />
                </div>
              </div>
              
              <div className="rounded-lg border bg-white p-4 shadow">
                <div className="text-base font-semibold">Erik Dengler</div>
                <div className="text-sm text-gray-600">
                  <a href="mailto:member2@example.com" className="text-blue-600 hover:underline">erik_dengler@sfu.ca</a>
                </div>
                <div className="text-sm mt-1">
                  Show & Tell 1: <br />
                  • Helped with CRUD <br />
                  • Attempted a Manual Search function (scrapped later, code reused for Map Activity) <br />
                  <br /> Show & Tell 2: <br />
                  • Created a Map Activity with hardcoded values, used the Fused Location Provider to get the user's current position, fetched and decoded the overview_polyline from the Google Directions API, and combined both pieces to generate a preview of the full route, making the API requests through OkHttp <br />
                  • Implementation of Google Places Autocomplete to help standardize user inputs <br />
                  • Extracting necessary information from AI Response to be ready to be sent to the DB <br />
                  • Took part in the Show & Tell 2 video <br />
                  <br /> Final: <br />
                  • Connected the map to the database based on the current user by removing hardcoded values, fetched and displayed their route data on the map, and listed all of their routes in a RecyclerView <br />
                  • Allow users to swap a singular location in the route with a new one and updating the database with it <br />
                  • Present a demo <br />
                </div>
              </div>

              <div className="rounded-lg border bg-white p-4 shadow">
                <div className="text-base font-semibold">Jun Hyeok Park</div>
                <div className="text-sm text-gray-600">
                  <a href="mailto:member2@example.com" className="text-blue-600 hover:underline">jpa188@sfu.ca</a>
                </div>
                <div className="text-sm mt-1">
                  Show & Tell 1: <br />
                  • Firebase setup <br />
                  • Created the presentation slides <br />
                  <br /> Show & Tell 2: <br />
                  • Designed a hierarchical Firestore structure with user-scoped data and GeoPoint location storage <br />
                  • Implemented full favorites system: save/remove favorites, status tracking, icons, and UI feedback <br />
                  • Built reactive architecture using coroutines, Repository pattern, LiveData, and non-blocking operations <br />
                  • Added menu options, loading states, and error handling for a smoother user experience <br />
                  • Took part in the Show & Tell 2 video <br />
                  <br /> Final: <br />
                  • Added custom favorite naming, search bar with real-time filtering, and improved viewing of full AI advice <br />
                  • Introduced edit mode with banners, Cancel/Done actions, and direct renaming via banner or menu <br />
                  • Preserved original AI advice during edits and regenerated new advice only when route data changes <br />
                  • Added confirmation dialogs, removed unnecessary rename popups, and reset the input screen after saving <br />
                </div>
              </div>
              
              <div className="rounded-lg border bg-white p-4 shadow">
                <div className="text-base font-semibold">Le Hue Anh Nguyen</div>
                <div className="text-sm text-gray-600">
                  <a href="mailto:member2@example.com" className="text-blue-600 hover:underline">lhn7@sfu.ca</a>
                </div>
                <div className="text-sm mt-1">
                  Show & Tell 1: <br />
                  • Designed the Account Page UI <br />
                  <br /> Show & Tell 2: <br />
                  • Built the full Account Page by pulling user data from Firebase Firestore and displaying the user's profile information <br />
                  • Set up the Light and Dark Theme so the app can switch between them smoothly and keep the UI consistent in both modes <br />
                  • Took part in the Show & Tell 2 video <br />
                  <br /> Final: <br />
                  • Implemented weather functionality by requesting location permission on the Account Page, retrieving the user's GPS coordinates to call the OpenWeather API, showing the city, emoji, temperature, and status, and adding permission checks, null checks, error handling, and fallback text like “Location Unavailable” or “Error” to prevent crashes and avoid blank UI states <br />
                  • Stored latitude and longitude in Firestore, including converting between LatLng and GeoPoint <br />
                  • Added the Common Places and Locations feature <br />
                  • Finished Auto Theme Mode and made sure the correct theme applies immediately when the app opens <br />
                </div>
              </div>

              <div className="rounded-lg border bg-white p-4 shadow">
                <div className="text-base font-semibold">Tushar Bector</div>
                <div className="text-sm text-gray-600">
                  <a href="mailto:member2@example.com" className="text-blue-600 hover:underline">tba58@sfu.ca</a>
                </div>
                <div className="text-sm mt-1">
                  Show & Tell 1: <br />
                  • Set up Firebase for the project, including Authentication and Firestore <br />
                  • Added required configuration files like google-services.json and updated build.gradle <br />
                  • Connected Firebase to the Android project and ensured app registration <br />
                  • Verified basic Firebase connectivity by checking for user session and logging status <br />
                  <br /> Show & Tell 2: <br />
                  • Designed and implemented the Sign In and Sign Up screens using Firebase Authentication <br />
                  • Built logout functionality to clear sessions and return users to the login screen <br />
                  • Added session persistence to keep users signed in until they explicitly log out <br />
                  • Connected navigation flow between authentication screens and the main app <br />
                  • Took part in the Show & Tell 2 video <br />
                  <br /> Final: <br />
                  • Added Forgot Password feature, allowing users to receive password reset emails <br />
                  • Created UI for password reset and integrated Firebase’s sendPasswordResetEmail method <br />
                  • Handled validation and error states for empty fields and failed email sending <br />
                  • Performed thorough testing across authentication flows and fixed bugs such as crashes from missing manifest entries or auth issues <br />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="faq" className="min-h-screen scroll-mt-20 flex flex-col items-center justify-center bg-emerald-50">
          <div className="mx-auto w-full max-w-4xl px-4 py-8">
            <h2 className="text-2xl font-semibold mb-6 text-center">FAQ</h2>
            <div className="space-y-8 text-gray-800">
              <div className="rounded-lg border bg-white p-6 shadow">
                <h3 className="text-lg font-semibold mb-2">
                  Q: How is your app’s place recommendation different from Google Maps?
                </h3>
                <p className="text-sm md:text-base leading-relaxed">
                  A: Google Maps shows places based on real-world data like user reviews, ratings, and popularity.
                  Our AI, on the other hand, uses semantic reasoning from the information it was trained on, so it’s
                  better at understanding vague requests like “a library where I can plug in my laptop.” It can also
                  help plan routes in a more flexible, natural way.
                </p>
                <br />
                <h3 className="text-lg font-semibold mb-2">
                  Q: If your app uses a large language model, why can’t I just ask ChatGPT directly?
                </h3>
                <p className="text-sm md:text-base leading-relaxed">
                  A: You can, but the process is pretty complicated. If you want to visit multiple places, you have to
                  give ChatGPT the exact address for every stop, and you also need to phrase your request very clearly
                  so it understands. Our app makes this much easier. With Google Maps Place Autocomplete, you only need
                  to enter part of the address. You just fill out a simple form, so you don’t need perfect wording, and
                  the AI gives you a clean, structured answer. You can also save your favorite routes and jump straight
                  into Google Maps navigation with one tap.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;